import { FunctionComponent, memo } from "react";
import { Box } from "@edgetier/client-components";

import { IProps } from "./anomaly-summary-value.types";
import "./anomaly-summary-value.scss";

/**
 * Container to show some detail about an anomaly.
 * @param props.children Summary content.
 * @param props.title    Title for the container.
 * @returns              Title and content.
 */
const AnomalySummaryValue: FunctionComponent<IProps> = ({ children, title }) => {
    return (
        <Box className="anomaly-summary-value">
            {title}
            <div className="anomaly-summary-value__value">{children}</div>
        </Box>
    );
};

export default memo(AnomalySummaryValue);
